import { DocumentType } from '@dc-shared-web/hooks/api/office/types'

export const formatDocumentTypes = (documentTypes: DocumentType[]) => {
  return documentTypes.map(({ uuid: value, name: label }) => ({
    value,
    label,
  }))
}
